"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_redux_1 = require("react-redux");
var QuickLinks = function () { return (React.createElement("div", null,
    React.createElement("h1", null, "Quick Links "),
    React.createElement("ul", null,
        React.createElement("li", null,
            React.createElement("a", { href: "https://github.com/microsoft/DNS-Challenge/tree/master/datasets" }, "Training and test datasets"),
            " "),
        React.createElement("li", null,
            React.createElement("a", { href: "https://github.com/microsoft/DNS-Challenge/tree/master" }, " Data synthesizer and unit tests scripts"),
            " "),
        React.createElement("li", null,
            React.createElement("a", { href: "https://github.com/microsoft/DNS-Challenge/tree/master/NSNet-baseline" }, " Baseline Speech Enhancement - NSNet ")),
        React.createElement("li", null,
            React.createElement("a", { href: "https://arxiv.org/ftp/arxiv/papers/2001/2001.08662.pdf" }, " Paper describing the challenge ")),
        React.createElement("li", null,
            "Contact: ",
            React.createElement("a", { href: "dns_challenge@microsoft.com" }, " dns_challenge@microsoft.com "))))); };
exports.default = react_redux_1.connect()(QuickLinks);
//# sourceMappingURL=Links.js.map